import * as React from 'react';
import { ThemeProvider, defaultTheme } from '@amzn/storm-ui';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { AuthProvider } from 'react-oidc-context';
import { createRoot } from 'react-dom/client';
import './index.css';
import { App } from './App';
import Dashboard from './features/InventoryDashboard/components/Dashboard';
import UserManagement from './features/UserManagement/components/UserManagement';
import RoleManagement from './features/RoleManagement/components/RoleManagement';
import AdSlotManagement from './features/BookingManagement/components/AdSlotManagement';
import AllowlistUpload from './features/FileUploadManagement/components/AllowlistUpload';
import { NotFound } from './features/Shared/components/NotFound';
import { RouteErrorElement } from './features/Shared/components/RouteErrorElement';
import { URLS } from './features/Shared/constants/url';
import { CreateArtEventForm } from './features/Shared/components/CreateArtEventForm';
import UserUnauthorized from './features/Shared/components/UserUnauthorized';
import { EditInventoryForm } from './features/EditInventory/components/EditInventoryForm';

import { getCognitoAuthConfig } from './features/Shared/config/authConfig';
import EditArtEvent from './features/EditArtEvent/components/EditArtEvent';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to find the root element');

const cognitoAuthConfig = getCognitoAuthConfig();

const root = createRoot(rootElement);
root.render(
  <React.StrictMode>
    <ThemeProvider theme={defaultTheme}>
      <AuthProvider {...cognitoAuthConfig}>
        <BrowserRouter>
          <Routes>
            <Route
              path={URLS.UNAUTHORIZED_ACCESS}
              element={<UserUnauthorized />}
              errorElement={<RouteErrorElement />}
            />
            <Route
              path="/"
              element={<App />}
              errorElement={<RouteErrorElement />}
            >
              <Route
                path=""
                element={<Dashboard />}
                errorElement={<RouteErrorElement />}
              />
              <Route
                path={URLS.DASHBOARD}
                element={<Dashboard />}
                errorElement={<RouteErrorElement />}
              />
              <Route
                path={URLS.EDIT_INVENTORY}
                element={<EditInventoryForm />}
                errorElement={<RouteErrorElement />}
              />
              <Route
                path={URLS.ART_EVENT}
                element={<EditArtEvent />}
                errorElement={<RouteErrorElement />}
              />
              <Route
                path={URLS.USERS}
                element={<UserManagement />}
                errorElement={<RouteErrorElement />}
              />
              <Route
                path={URLS.ROLES}
                element={<RoleManagement />}
                errorElement={<RouteErrorElement />}
              />
              <Route
                path={URLS.BOOKINGS}
                element={<AdSlotManagement />}
                errorElement={<RouteErrorElement />}
              />
              <Route
                path={URLS.ALLOWLIST}
                element={<AllowlistUpload />}
                errorElement={<RouteErrorElement />}
              />
              <Route
                path={URLS.ALLOWLIST_AE}
                element={<AllowlistUpload />}
                errorElement={<RouteErrorElement />}
              />
              <Route
                path={URLS.ALLOWLIST_INVENTORY}
                element={<AllowlistUpload />}
                errorElement={<RouteErrorElement />}
              />
              <Route
                path={URLS.ALLOWLIST_ADVERTISERS}
                element={<AllowlistUpload />}
                errorElement={<RouteErrorElement />}
              />
              <Route
                path={URLS.ALLOWLIST_CATEGORY}
                element={<AllowlistUpload />}
                errorElement={<RouteErrorElement />}
              />
              <Route
                path={URLS.ALLOWLIST_TYPE_OF_PURCHASE}
                element={<AllowlistUpload />}
                errorElement={<RouteErrorElement />}
              />
              <Route
                path={URLS.CREATE_ART_EVENT}
                element={<CreateArtEventForm />}
                errorElement={<RouteErrorElement />}
              />
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  </React.StrictMode>
);
